import React, { FC, HTMLAttributes } from 'react'
import { Box, BoxProps } from '@chakra-ui/core'

export interface Props extends HTMLAttributes<BoxProps> {
  value: number
  size?: String
  light?: boolean
}

export const QuantityBox: FC<Props> = ({ value = 0, light = false, size, ...props }) => {
  return (
    <Box
      borderRadius="4px"
      paddingY="3px"
      paddingX={size === 'big' ? '8px' : '5px'}
      bg={light ? 'primary.50' : 'primary.500'}
      width="fit-content"
      fontFamily="body"
      color="white"
      fontSize={size === 'big' ? '14px' : '8px'}
      {...props}
    >
      {value >= 0 ? value : 0}
    </Box>
  )
}
